import constate from 'constate'
import { useAuth0 } from 'utils/auth'
import { useGetUpsellProducts } from 'dataQueries'
import { useMemo } from 'react'
import { useUserData } from 'components/contexts/UserDataContext'

/** Props required for the RenovationProductsProvider context. */
interface UpsellProductsProviderProps {
  /** The session ID of the user. */
  assignmentId: string
}

function useGalleryUpsellProductsAPI({
  assignmentId,
}: UpsellProductsProviderProps) {


  const { roles } = useAuth0()
  const { userPropertyWorkspaceId } = useUserData()

  const getUpsellProduct = useGetUpsellProducts(assignmentId, userPropertyWorkspaceId!, roles)

  // Query response data returning the renovation product kind (COMMERCIAL_RENOVATION).
  const upsellRenovationProduct = useMemo(() => {
    if (!getUpsellProduct.isSuccess || !getUpsellProduct.data?.data) return undefined

    return getUpsellProduct.data.data
  }, [getUpsellProduct.data?.data, getUpsellProduct.isSuccess])

  return {
    upsellRenovationProduct
  }
}

export const [GalleryUpsellProductsContextProvider, useGalleryUpsellProducts] = constate(useGalleryUpsellProductsAPI)
